import { localize, readAppLanguage } from '../i18n';

// Format an already stored wall clock. Do not convert or change its schedule zone.
export function formatMedicationClockList(times = []) {
    const language = readAppLanguage();
    return times.map(time => {
        const [hour, minute] = time.split(':');
        const h = Number(hour);
        if (language !== 'ko') {
            return new Intl.DateTimeFormat(language, {
                hour: 'numeric', minute: '2-digit', hour12: language === 'en', timeZone: 'UTC',
            }).format(new Date(Date.UTC(2000, 0, 1, h, Number(minute))));
        }
        const period = localize(h < 12 ? '오전' : '오후');
        const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
        return `${period} ${h12}:${minute}`;
    }).join(', ');
}
